import React from 'react';
import { VisitStatus } from '@/types/visit.types';

interface VisitStatusBadgeProps {
  status: VisitStatus;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const statusConfig: Record<VisitStatus, { label: string; colors: string }> = {
  SCHEDULED: {
    label: 'Scheduled',
    colors: 'bg-blue-100 text-blue-800 border-blue-200',
  },
  COMPLETED: {
    label: 'Completed',
    colors: 'bg-green-100 text-green-800 border-green-200',
  },
  NO_SHOW: {
    label: 'No Show',
    colors: 'bg-orange-100 text-orange-800 border-orange-200',
  },
  CANCELLED: {
    label: 'Cancelled',
    colors: 'bg-red-100 text-red-800 border-red-200',
  },
  RESCHEDULED: {
    label: 'Rescheduled',
    colors: 'bg-purple-100 text-purple-800 border-purple-200',
  },
};

const sizeStyles = {
  sm: 'px-2 py-0.5 text-xs',
  md: 'px-2.5 py-1 text-sm',
  lg: 'px-3 py-1.5 text-base',
};

export const VisitStatusBadge: React.FC<VisitStatusBadgeProps> = ({
  status,
  size = 'md',
  className = '',
}) => {
  const config = statusConfig[status] || statusConfig.SCHEDULED;

  return (
    <span
      className={`
        inline-flex items-center font-medium rounded-full border
        ${config.colors}
        ${sizeStyles[size]}
        ${className}
      `}
    >
      {config.label}
    </span>
  );
};

export const getVisitStatusLabel = (status: VisitStatus): string => {
  return statusConfig[status]?.label || status;
};

export const getAllVisitStatuses = (): { value: VisitStatus; label: string }[] => {
  return Object.entries(statusConfig).map(([value, { label }]) => ({
    value: value as VisitStatus,
    label,
  }));
};

export default VisitStatusBadge;
